(function () {
  function send(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('wbc:analytics', { detail: payload }));
  }

  function bind(root) {
    if (!root || root.dataset.wbcEventsBound === 'true') return;
    root.dataset.wbcEventsBound = 'true';
    var handle = root.getAttribute('data-collection-handle') || '';
    var grid = root.closest('.container') && root.closest('.container').querySelector('[data-wbc-product-grid]');
    var viewed = false;

    function view() {
      if (viewed) return;
      viewed = true;
      send('wbc_collection_view', { collection_handle: handle });
    }

    if (grid && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          view();
          observer.disconnect();
        }
      }, { threshold: 0.15 });
      observer.observe(grid);
    } else {
      view();
    }

    root.closest('.container').addEventListener('click', function (event) {
      var target = event.target;
      var offer = target.closest('[data-wbc-offer-link]');
      if (offer) {
        send('wbc_collection_offer_click', { collection_handle: handle, destination: offer.getAttribute('href') || '' });
        return;
      }

      var card = target.closest('[data-wbc-product-card]');
      if (!card) return;
      var detail = {
        collection_handle: handle,
        product_id: card.getAttribute('data-product-id') || '',
        product_handle: card.getAttribute('data-product-handle') || '',
        price_cents: Number(card.getAttribute('data-product-price') || 0)
      };
      if (target.closest('[data-wbc-select-size]')) {
        send('wbc_collection_select_size_click', detail);
      } else if (target.closest('a[href]')) {
        send('wbc_collection_product_click', detail);
      }
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-wbc-collection-events]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
